import z from 'zod';

/** Why this contactMessage document was created (drives admin email copy). */
export enum ContactMessageSource {
  CONTACT = 'contact',
  NEW_USER_REGISTRATION = 'newUserRegistration',
}

export const contactMessageSourceSchema = z.nativeEnum(ContactMessageSource).optional();
